import { render, staticRenderFns } from "./CustomIconButton.vue?vue&type=template&id=33adf610&scoped=true&"
import script from "./CustomIconButton.vue?vue&type=script&lang=js&"
export * from "./CustomIconButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomIconButton.vue?vue&type=style&index=0&id=33adf610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adf610",
  null
  
)

export default component.exports